export const passwordHasMinLength = (value) =>
  typeof value === "string" && value.length >= 8;

/** Upper, lower, number, special — matches PASSWORD_REGEX charset (minus length). */
export const passwordHasCharsetRules = (value) =>
  /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_])/.test(
    String(value || ""),
  );
